import { Controller } from "@hotwired/stimulus"

// The Schedule Training slideover (TASK-292.2): shows the Where panel for the
// chosen kind, the outside-trainer name, adds the quick-add groups to the
// attendee select (a Tom Select), reloads the course's groups when the course
// changes and the visit-clash notice when the date, time or people change.
export default class extends Controller {
  static targets = ["hint", "panel", "trainer", "trainerName", "attendees", "course", "groups", "clashes"]
  static values = { groupsUrl: String, clashesUrl: String }

  connect() {
    this.timer = null
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  kindChanged(event) {
    const kind = event.target.value
    this.panelTargets.forEach((panel) => panel.classList.toggle("hidden", panel.dataset.kind !== kind))
  }

  trainerChanged() {
    this.trainerNameTarget.classList.toggle("hidden", this.trainerTarget.value !== "")
  }

  courseChanged() {
    const query = `training_course_id=${encodeURIComponent(this.courseTarget.value)}`
    if (this.hasHintTarget) this.hintTarget.src = `${this.groupsUrlValue}?${query}&part=hint`
    if (this.hasGroupsTarget) this.groupsTarget.src = `${this.groupsUrlValue}?${query}`
  }

  quickAdd(event) {
    const ids = JSON.parse(event.currentTarget.dataset.ids || "[]")
    const select = this.attendeesTarget
    const ts = select.tomselect
    if (ts) {
      ts.setValue([...new Set([...ts.items, ...ids])])
    } else {
      Array.from(select.options).forEach((option) => {
        if (ids.includes(option.value)) option.selected = true
      })
    }
    this.changed()
  }

  // Any field change: look for visit clashes again, a moment after the last one.
  changed() {
    if (!this.hasClashesTarget) return
    if (this.timer) clearTimeout(this.timer)
    this.timer = setTimeout(() => this.refreshClashes(), 250)
  }

  refreshClashes() {
    const params = new URLSearchParams()
    const form = this.element
    ;["date", "start_time", "end_time"].forEach((name) => {
      const field = form.querySelector(`[name='${name}']`)
      if (field && field.value) params.set(name, field.value)
    })
    Array.from(this.attendeesTarget.selectedOptions).forEach((option) => {
      if (option.value) params.append("member_ids[]", option.value)
    })
    this.clashesTarget.src = `${this.clashesUrlValue}?${params.toString()}`
  }
}
